import { Hourglass, CalendarDays } from "lucide-react";
import { formatExamDate, type SubjectCountdown } from "@/lib/pepCountdown";

/**
 * Compact countdown strip for a subject tile: "PEP in 192 days · Wed 17 Mar". Turns amber inside
 * 90 days and red inside 30, so the pressure builds as the sitting approaches.
 */
export function PepCountdownChip({ countdown, tint, className = "", testId }: { countdown: SubjectCountdown | null; tint: string; className?: string; testId?: string }) {
  if (!countdown) return null;
  const urgent = countdown.isActive || countdown.days <= 30;
  const soon = !urgent && countdown.days <= 90;
  const cls = urgent ? "bg-rose-500 text-white" : soon ? "bg-amber-400 text-amber-950" : tint;
  return (
    <div className={`inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-[11px] font-semibold ${cls} ${className}`} data-testid={testId} title={countdown.windowName}>
      <Hourglass className={`w-3.5 h-3.5 ${urgent ? "animate-pulse" : ""}`} />
      <span className="tabular-nums">{countdown.isActive ? "PEP is this week" : countdown.days === 1 ? "PEP tomorrow" : `PEP in ${countdown.days} days`}</span>
      <span className="opacity-80 inline-flex items-center gap-1"><CalendarDays className="w-3 h-3" /> {formatExamDate(countdown.date)}</span>
    </div>
  );
}
